import { put, takeLatest, select } from 'redux-saga/effects'
import * as Eff from 'redux-saga/effects' // tslint:disable-line:no-duplicate-imports
import toastr from 'toastr'
import 'toastr/build/toastr.css'

import Logger from '@Utils/Logger'
import { IAction, ISuccessResponse } from '@Root/types'

import {
  fetchVocabularies,
  fetchVocabulariesSuccess,
  fetchVocabulariesFailure,
  createVocabularySuccess,
  createVocabularyFailure,
  updateVocabularySuccess,
  updateVocabularyFailure,
  deleteVocabularySuccess,
  deleteVocabularyFailure,
} from './actions'

import {
  VocabularyActionTypes,
  IFetchVocabulariesSuccessResponseBody,
  ICreateVocabularyPayload,
  IUpdateVocabularyPayload,
  IDeleteVocabularyPayload,
  IFetchVocabulariesPayload,
} from './types'

import * as API from './api'

const call: any = Eff.call

function* fetchVocabulariesSaga(action: IAction<IFetchVocabulariesPayload>) {
  try {
    const response: ISuccessResponse<IFetchVocabulariesSuccessResponseBody> = yield call(API.fetchVocabularies, action.payload)
    const payloadResponse = response.data
    yield put(fetchVocabulariesSuccess(payloadResponse))
  } catch (e) {
    Logger.error(e, 'Vocabulary lists could not be loaded')
    yield put(fetchVocabulariesFailure())
  }
}

function* createVocabularySaga(action: IAction<ICreateVocabularyPayload>) {
  try {
    const { payload } = action
    yield call(API.createVocabulary, payload)
    yield put(createVocabularySuccess())
    toastr.success('', 'Vocabulary list created')
    yield put(fetchVocabularies({ workspaceId: payload.workspaceId }))
  } catch (e) {
    Logger.error(e, 'Vocabulary list could not be created')
    yield put(createVocabularyFailure())
  }
}

function* updateVocabularySaga(action: IAction<IUpdateVocabularyPayload>): Generator<any, any, any> {
  try {
    const { payload } = action
    yield call(API.updateVocabulary, payload)
    yield put(updateVocabularySuccess())
    if (payload.utterances) {
      toastr.success('', 'Changes saved')
    } else {
      toastr.success('', 'Name saved')
    }
    const state = yield select()
    yield put(fetchVocabularies({ workspaceId: state.workspaces.currentWorkspaceId }))
  } catch (e) {
    Logger.error(e, 'Changes could not be saved')
    yield put(updateVocabularyFailure())
  }
}

function* deleteVocabularySaga(action: IAction<IDeleteVocabularyPayload>): Generator<any, any, any> {
  try {
    yield call(API.deleteVocabulary, action.payload)
    yield put(deleteVocabularySuccess())
    toastr.success('', 'Vocabulary list deleted')
    const state = yield select()
    yield put(fetchVocabularies({ workspaceId: state.workspaces.currentWorkspaceId }))
  } catch (e) {
    Logger.error(e, 'Vocabulary list could not be deleted')
    yield put(deleteVocabularyFailure())
  }
}

function* vocabularySagas() {
  yield takeLatest(VocabularyActionTypes.FETCH_VOCABULARIES, fetchVocabulariesSaga)
  yield takeLatest(VocabularyActionTypes.CREATE_VOCABULARY, createVocabularySaga)
  yield takeLatest(VocabularyActionTypes.UPDATE_VOCABULARY, updateVocabularySaga)
  yield takeLatest(VocabularyActionTypes.DELETE_VOCABULARY, deleteVocabularySaga)
}

export default vocabularySagas
